import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { lightTheme } from "@themes/Theme";
import PricingPageContent from "./PricingPageContent";

const PricingPageContainer = styled.div`
    height: 100vh;
    overflow-y: auto;
`;

interface ProTierUpgradePageProps {}
export default function ProTierUpgradePage(props: ProTierUpgradePageProps) {
    return (
        <ThemeProvider theme={lightTheme}>
            <PricingPageContainer>
                <PricingPageContent upgradeContext={"default"} hideFreeTier={true} hideTestimonials={true} />
            </PricingPageContainer>
        </ThemeProvider>
    );
}
